var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H3.5A1.5 1.5 0 002 5.5v7A1.5 1.5 0 003.5 14h7a1.5 1.5 0 001.5-1.5V10h-1v2.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5H6V4z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.5V8h-1V4.06l-6.47 6.47-1.06-1.06L11.94 3H8V2h5.5a.5.5 0 01.5.5z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aCBvcGFjaXR5PSIwLjc1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNEgzLjVDMi42NzE1NyA0IDIgNC42NzE1NyAyIDUuNVYxMi41QzIgMTMuMzI4NCAyLjY3MTU3IDE0IDMuNSAxNEgxMC41QzExLjMyODQgMTQgMTIgMTMuMzI4NCAxMiAxMi41VjEwSDExVjEyLjVDMTEgMTIuNzc2MSAxMC43NzYxIDEzIDEwLjUgMTNIMy41QzMuMjIzODYgMTMgMyAxMi43NzYxIDMgMTIuNVY1LjVDMyA1LjIyMzg2IDMuMjIzODYgNSAzLjUgNUg2VjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC45Ii8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wMDAxIDIuNVY4SDEzLjAwMDFWNC4wNjA2Nkw2LjUzMDM5IDEwLjUzMDNMNS40Njk3MyA5LjQ2OTY3TDExLjkzOTQgM0g4LjAwMDA2TDguMDAwMDYgMkgxMy41MDAxQzEzLjYzMjcgMiAxMy43NTk4IDIuMDUyNjggMTMuODUzNiAyLjE0NjQ1QzEzLjk0NzQgMi4yNDAyMiAxNC4wMDAxIDIuMzY3MzkgMTQuMDAwMSAyLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC45Ii8+Cjwvc3ZnPg==";
export { SvgExternalLink as ReactComponent };